import classNames from 'classnames';
import React, { useCallback } from 'react';
import FontAwesome from 'react-fontawesome';
import styles from './TimelineZoomControl.module.scss';

interface Props {
  setPixelsPerMinute: (pixelsPerMinute: number) => void;
  inline: boolean | null | undefined;
  pixelsPerMinute: number;
  minimumPixelsPerMinute?: number;
  maximumPixelsPerMinute?: number;
}

export const TimelineZoomControl = React.memo<Props>(
  ({
    setPixelsPerMinute,
    inline,
    pixelsPerMinute,
    minimumPixelsPerMinute = 1,
    maximumPixelsPerMinute = 6,
  }) => {
    const isPlusDisabled = pixelsPerMinute >= maximumPixelsPerMinute;
    const isMinusDisabled = pixelsPerMinute <= minimumPixelsPerMinute;

    const handleIncreaseSize = useCallback(() => {
      if (pixelsPerMinute + 1 <= maximumPixelsPerMinute) {
        setPixelsPerMinute(pixelsPerMinute + 1);
      }
    }, [maximumPixelsPerMinute, pixelsPerMinute, setPixelsPerMinute]);

    const handleDecreaseSize = useCallback(() => {
      if (pixelsPerMinute - 1 >= minimumPixelsPerMinute) {
        setPixelsPerMinute(pixelsPerMinute - 1);
      }
    }, [minimumPixelsPerMinute, pixelsPerMinute, setPixelsPerMinute]);

    return (
      <div className={classNames(styles.container, { [styles.isInline]: inline })}>
        <button
          disabled={isPlusDisabled}
          className={styles.plusButton}
          onClick={handleIncreaseSize}
        >
          <FontAwesome name="plus" />
        </button>
        <button
          disabled={isMinusDisabled}
          className={styles.minusButton}
          onClick={handleDecreaseSize}
        >
          <FontAwesome name="minus" />
        </button>
      </div>
    );
  }
);

TimelineZoomControl.displayName = 'TimelineZoomControl';
